import React from 'react';
import { Delivery } from '@one-thd/sui-icons';
import { LearnMore } from './LearnMore';

export const LearnMoreDelivery = () => {
  return (
    <LearnMore
      icon={<Delivery size="large" color="brand" />}
      title="Ship To Home"
      link="/c/About_Your_Online_Order#sth"
    >
      <p>Free 2-day delivery</p>
      <p>Thousands of online items eligible</p>
    </LearnMore>
  );
};

LearnMoreDelivery.displayName = 'LearnMoreDelivery';
